import { render, staticRenderFns } from "./UserTransit.vue?vue&type=template&id=1ef386d2&scoped=true"
import script from "./UserTransit.vue?vue&type=script&lang=js"
export * from "./UserTransit.vue?vue&type=script&lang=js"
import style0 from "./UserTransit.vue?vue&type=style&index=0&id=1ef386d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef386d2",
  null
  
)

export default component.exports